import {
  ChangeDetectionStrategy,
  Component,
  HostBinding,
  Inject,
  Input,
  DOCUMENT,
} from '@angular/core';

@Component({
  selector: 'rd-core-bypass-block',
  template: '',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class BypassBlockComponent {
  constructor(@Inject(DOCUMENT) protected document: any) {
    this.document = document as Document;
  }
  @HostBinding('class.rd-core-bypass-block') componentClass = true;
  @Input() isLoggedIn = false;

  focusOnElement(containingBody: string): void {
    this.document
      .querySelector(`${containingBody}.bypass-block-target`)
      .focus();
  }
}
